const CARD_WIDTH = { mobile: 95, desktop: 155 } as const;

/** ProviderCard is wider on mobile. */
const PROVIDER_CARD_WIDTH = { mobile: 139, desktop: 155 } as const;

const CARD_GAP = { mobile: 16, desktop: 20 } as const;

const SCROLLER_SKELETON_SIZE = 10;

/** One grid page and how many placeholders a grid skeleton holds. */
const GRID_PAGE_SIZE = 32;

/** Max safe signed 32-bit int for the backend; the default (unranked) game priority */
const INT32_MAX = Math.pow(2, 31) - 1;

/** Card scrollers stop here and show a View All tile. */
const SCROLLER_GAMES_LIMIT = 20;

/** How many cards the arrows move per click. */
const ARROW_SCROLL_STEP = 3;

export {
  CARD_WIDTH,
  PROVIDER_CARD_WIDTH,
  CARD_GAP,
  SCROLLER_SKELETON_SIZE,
  GRID_PAGE_SIZE,
  INT32_MAX,
  SCROLLER_GAMES_LIMIT,
  ARROW_SCROLL_STEP,
};
